// extracted by mini-css-extract-plugin
export default {"content":"loading-content_content__MVtHD","overlay":"loading-content_overlay__94IMP"};